import { render, staticRenderFns } from "./Bom.vue?vue&type=template&id=13018d5e&"
import script from "./Bom.vue?vue&type=script&lang=js&"
export * from "./Bom.vue?vue&type=script&lang=js&"
import style0 from "./Bom.vue?vue&type=style&index=0&id=13018d5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports